module.exports = __webpack_public_path__ + "media/images/flags/32/Mali-b2352a2bebd0fd3bd6bc0e19de5573df.png";